import { useState, useEffect, useMemo } from "react";
import axios from "../config/axios";
import PageWrapper from "../components/common/PageWrapper";
import Header from "../components/common/Header";
import BodyWrapper from "../components/common/BodyWrapper";
import Footer from "../components/common/Footer";
import ReviewSlider from "../components/reviewPartials/ReviewSlider";
import ReviewSubmissionForm from "../components/reviewPartials/ReviewSubmissionForm";
import { useGeneral } from "../components/contexts/GeneralContext";
import FullScreenLoading from "../components/common/loading/FullScreenLoading";
import ApiErrorMessage from "../components/common/ApiErrorMessage";
import NoItemsFound from "../components/common/NoItemsFound";
const usePageContent = () => {
  const [loading, setLoading] = useState(true);
  const [content, setContent] = useState([]);
  const [error, setError] = useState("");
  const { discountCoupons } = useGeneral();

  useEffect(() => {
    let active = true;

    (async () => {
      try {
        const { data } = await axios.get("testimonials");
        if (active) setContent(data);
      } catch (err) {
        console.error(err);
        if (active) setError("Failed to load plans. Please try again later.");
      } finally {
        if (active) setLoading(false);
      }
    })();

    return () => {
      active = false;
    };
  }, []);

  return { content, loading, error, discountCoupons };
};

const useScrollToTop = () => {
  useEffect(() => {
    const timer = setTimeout(() => {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }, 100);
    return () => clearTimeout(timer);
  }, []);
};
const ReviewsPage = () => {
  const { content, loading, error, discountCoupons } = usePageContent();
  useScrollToTop();

  return (
    <>
      {loading && <FullScreenLoading />}
      <PageWrapper loading={loading} className="bg-bg min-h-screen">
        <Header code={discountCoupons} />
        <BodyWrapper loading={loading} className="">
          {
            // ✅ Two-column grid when content exists and no error
            <div className="grid grid-cols-1 xl:grid-cols-2 gap-4 w-full items-start">
              {error ? (
                <ApiErrorMessage
                  message1="Failed to load testimonials"
                  message2="Please check your connection and try again."
                />
              ) : (
                content?.items?.length > 0 && (
                  <div>
                    <ReviewSlider reviews={content?.items} />
                  </div>
                )
              )}
              <div>
                <ReviewSubmissionForm />
              </div>
            </div>
          }
        </BodyWrapper>

        <Footer />
      </PageWrapper>
    </>
  );
};

export default ReviewsPage;
